import type { Review } from "@/data/reviewTypes";

export const CARLSBAD_CA_REVIEWS: Review[] = [
  { name: "Miguel K.", initials: "MK", rating: 5, date: "1 week ago", text: "Carlsbad pickup for our 14-person crew — Sprinter was spotless, driver knew every Carlsbad shortcut. Booking again for sure." },
  { name: "Sara R.", initials: "SR", rating: 5, date: "3 weeks ago", text: "Bachelorette weekend based in Carlsbad. Easy delivery to our Airbnb, captain\u2019s chairs, cold AC all day. Perfect for our group." },
  { name: "Devon T.", initials: "DT", rating: 5, date: "1 month ago", text: "Booked the 15-passenger for a Carlsbad event. On-time, full tank, no surprise charges — straight-forward and reliable." },
];
